module.exports = __webpack_public_path__ + "static/media/contact-us-image.45cf4aa1.jpg";